import FlexibleLink from 'src/components/ui/FlexibleLink/FlexibleLink'
import { Image } from 'src/components/ui/Image'
import type { EditorialCardItemData } from 'src/types/editorialCards2'

interface Props {
  item: EditorialCardItemData
}

export default function EditorialCardItem({ item }: Props) {
  return (
    <div
      data-testid="editorial-card-item"
      className="group relative w-full min-w-0 overflow-hidden md:flex-1 md:h-[653px] md:transition-[flex] md:duration-[550ms] md:ease-[cubic-bezier(.25,.8,.25,1)] md:hover:flex-[3] md:focus-within:flex-[3]"
    >
      <Image
        src={item.imageSrc}
        alt={item.imageAlt}
        className="h-full max-h-[478px] md:h-[653px] md:max-h-[653px] w-full object-cover object-[50%_12%] transition-transform duration-500 ease-out"
      />

      <span className="absolute bottom-0 left-0 z-10 w-full flex flex-col gap-4 p-4 md:p-6">
        <span className="text-[34px] uppercase italic font-extrabold leading-[0.68] text-white md:text-[37px] [text-shadow:0_2.18px_17.41px_#00000066]">
          {item.title}
        </span>

        <FlexibleLink
          linkUrl={item.ctaUrl}
          classNames="w-fit min-w-[121px] md:min-w-[132px] flex justify-center h-[37px] shrink-0 items-center uppercase bg-white border-0 px-5 text-[14px] font-extrabold text-restructure-neutral-23 shadow-[0_2px_10px_0_#0000002E]"
          title={`${item.title} - ${item.ctaText}`}
        >
          {item.ctaText}
        </FlexibleLink>
      </span>
    </div>
  )
}
